import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import { Row, Col, Button, Card, CardBody, Input, InputGroup, InputGroupAddon, Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faSearch, faCaretDown, faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { Typeahead, AsyncTypeahead } from 'react-bootstrap-typeahead';
import { debounce } from 'throttle-debounce';
import _ from 'lodash';
import Validation from '../../services/Validation';
import OfftakeEntryService from '../../services/OfftakeEntryService';

class AddOfftakeEntryRightPan extends Component {

  constructor(props) {
    super(props);
    this.state = {
      controls: props.controls,
      isValidForm: props.isValidForm,
      saveClick: props.saveClick,
      updateClick: props.updateClick,
      dealerData: [],
      subsidiaryData: [],
      skuIdData: [],
      selectedDealer: this.props.selectedDealer,
      selectedInvoiceInFavorOf: this.props.selectedInvoiceInFavorOf
    };
  }

  componentWillMount() {
    this.getsubsidiaryData();
    this.getDealerData();
  }

  componentDidMount() {
    let { isValidForm, controls } = this.state;
    let { selectedDealer, selectedInvoiceInFavorOf } = this.state;

    setTimeout(() => {
      if (this.props.offtakeEntryQuery.uuid) {
        selectedDealer = this.props.selectedDealer;
        selectedInvoiceInFavorOf = this.props.selectedInvoiceInFavorOf;
        isValidForm = true;
        controls.dealerName.touched = true;
        controls.invoiceInFavorOf.touched = true;
        controls.invoiceNumber.touched = true;
        controls.purchaseDate.touched = true;

        _.forEach(controls.productDescription.value, (item) => {
          item.isValid = true;
        });

        this.setState({ isValidForm, selectedDealer, selectedInvoiceInFavorOf });
      }
    }, 3000);
  }

  handleInputChange = (e) => {
    let { selectedInvoiceInFavorOf, selectedDealer } = this.state;
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;
    // return;
    controls[controlName].touched = true;
    controls[controlName].value = controlValue;
    if (controlName === 'invoiceInFavorOf') {
      selectedInvoiceInFavorOf = controlValue.subsidiary_name;
    }

    if (controlName === 'dealerName') {
      selectedDealer = controlValue;
    }
    this.setState({ controls, selectedInvoiceInFavorOf, selectedDealer });

    this.handleValidation();
  }

  handleValidation = () => {
    const { controls } = this.state;
    let { isValidForm } = this.state;
    const { productDescription } = controls;
    let { invoiceNumber, purchaseDate, dealerName, invoiceInFavorOf } = controls;

    if (invoiceNumber.touched === true) {
      invoiceNumber = Validation.notNullValidator(invoiceNumber);
      invoiceNumber.valid = !invoiceNumber.nullValue;
    }

    if (purchaseDate.touched === true) {
      purchaseDate = Validation.notNullValidator(purchaseDate);
      purchaseDate.valid = !purchaseDate.nullValue;
    }

    if (dealerName.touched === true) {
      dealerName = Validation.notNullValidator(dealerName);
      dealerName.valid = !dealerName.nullValue;
    }

    if (invoiceInFavorOf.touched === true) {
      invoiceInFavorOf = Validation.notNullValidator(invoiceInFavorOf);
      invoiceInFavorOf.valid = !invoiceInFavorOf.nullValue;
    }

    if (invoiceNumber.valid && purchaseDate.valid && dealerName.valid && invoiceInFavorOf.valid &&
      _.some((productDescription || []).value, { isValid: true })) {
      isValidForm = true;
    } else {
      isValidForm = false;
    }

    this.setState({ controls, isValidForm });
  }

  handleProductDescriptionChange = (value, index, type) => {
    const controlValue = value;
    const { controls } = this.state;
    if (type === 'description') {
      controls.productDescription.value[index].description = controlValue;
    } else {
      controls.productDescription.value[index].quantity = controlValue;
    }

    if (controls.productDescription.value && controls.productDescription.value[index] && controls.productDescription.value[index].description && controls.productDescription.value[index].description.sku_id && controls.productDescription.value[index].quantity) {
      controls.productDescription.value[index].isValid = true;
    } else {
      controls.productDescription.value[index].isValid = false;
    }
    this.handleValidation();
    this.setState({ controls });
  }

  addMoreEntries = () => {
    const { controls } = this.state;
    controls.productDescription.value.push({ description: { sku_id: '', name: '' }, quantity: '', isValid: false });
    this.setState({ controls });
  }

  getDealerData = async () => {
    // this.handleInputChange({ target: { name: 'dealerName', value: query } });
    const { offtakeEntryQuery } = this.props;
    let { dealerData } = this.state;
    try {
      const { data } = await OfftakeEntryService.getDealerName(offtakeEntryQuery.fleetId ? offtakeEntryQuery.fleetId : '');
      if (data) {
        dealerData = data.data;
      }
      this.setState({ dealerData });
    } catch (error) {
      console.log(error);
    }
  }

  getSKUId = async (skuId = '') => {
    let { skuIdData } = this.state;
    try {
      const { data } = await OfftakeEntryService.getSKUID({ type: 'bus', name: skuId });
      if (data) {
        skuIdData = data.data;
      }
      this.setState({ skuIdData });
    } catch (error) {
      console.log(error);
    }
  }

  getsubsidiaryData = async () => {
    let { subsidiaryData } = this.state;
    const { offtakeEntryQuery } = this.props;

    try {
      const { data } = await OfftakeEntryService.getSubsadairy(offtakeEntryQuery.fleetId ? offtakeEntryQuery.fleetId : '');
      if (data) {
        subsidiaryData = data.data;
      }
      this.setState({ subsidiaryData });
    } catch (error) {
      console.log(error);
    }
  }

  removeProductDesc = (index) => {
    const { controls } = this.state;
    controls.productDescription.value.splice(index, 1);
    this.handleValidation();
    this.setState({ controls });
  }

  render() {
    const { controls, dealerData, selectedDealer, selectedInvoiceInFavorOf, isValidForm, subsidiaryData, skuIdData, saveClick, updateClick } = this.state;
    const { invoiceNumber, purchaseDate, productDescription } = controls;
    const { uploadedFile } = this.props;
    return (
      <div>
        <Row>
          <Col className="title-right-pan">
            Add Invoice Details
          </Col>
          <Col>
            {
              this.props.offtakeEntryQuery.uuid ?
                <Button disabled={!isValidForm || uploadedFile.length === 0 /* !this.props.uploadedFileData.url */} className="mb-1 mr-1 btn-pill action-button profile-save-button pull-right" color="warning" onClick={updateClick}>Save</Button>
                :
                <Button disabled={!isValidForm || uploadedFile.length === 0 /* !this.props.uploadedFileData.url */} className="mb-1 mr-1 btn-pill action-button profile-save-button pull-right" color="warning" onClick={saveClick}>Save</Button>

            }
          </Col>
        </Row>

        <Row style={{ marginLeft: '-20px', marginRight: '-20px' }}>
          <Col style={{ padding: '0' }}>
            <hr />
          </Col>
        </Row>

        <Row>
          <Col>
            <Label className="label-right-pan">Invoice Number<span className="required-field"> *</span></Label>
            <Input
              type="text"
              name="invoiceNumber"
              id="invoiceNumber"
              placeholder="Type here"
              value={invoiceNumber.value}
              onChange={this.handleInputChange}
            />
          </Col>
          <Col>
            <Label className="label-right-pan">Purchase Date<span className="required-field"> *</span></Label>
            <br />
            <Label onClick={e => this.bday.state.open && e.preventDefault()} style={{ width: '100%' }}>
              <InputGroup className="social-detail-date">
                <DatePicker className="form-control"
                  selected={purchaseDate.value}
                  onChange={(e) => this.handleInputChange({ target: { name: 'purchaseDate', value: e } })}
                  showMonthDropdown
                  ref={r => this.bday = r}
                  placeholderText="Purchase Date"
                  // shouldCloseOnSelect={true}
                  showYearDropdown
                  shouldCloseOnSelect
                  maxDate={new Date()}
                  dropdownMode="select"
                  style={{ zIndex: 'auto' }}
                  dateFormat="dd/MM/yyyy"
                // onFocus={this.props.activeFragment ? this.props.activeFragment.bind(this, 'social') : null}
                />
                <InputGroupAddon addonType="append" >
                  <div className="input-group-text" style={{ zIndex: 'auto !important', cursor: 'pointer' }}>
                    <FontAwesomeIcon htmlFor="datepicker" icon={faCalendarAlt} />
                  </div>
                </InputGroupAddon>
              </InputGroup>
            </Label>
          </Col>
        </Row>

        <Row style={{ marginTop: '12px' }}>
          <Col>
            <Label className="label-right-pan">Dealer Name<span className="required-field"> *</span></Label>
            <div className="d-flex-row vehical-sku-id-search">
              <Typeahead
                id="dealerName"
                filterBy={['dealer_name']}
                options={dealerData}
                allowNew
                onBlur={(e) => { this.handleInputChange({ target: { name: 'dealerName', value: e && e.target && e.target.value } }); }}
                newSelectionPrefix="No match found, click here to add: "
                labelKey="dealer_name"
                onChange={(e) => { this.handleInputChange({ target: { name: 'dealerName', value: e && e[0] && e[0].dealer_name } }); }}
                name="dealerName"
                placeholder="Type Here"
                renderMenuItemChildren={(selectedItem) => {
                  return <>{selectedItem.dealer_name}</>;
                }}
                selected={selectedDealer ? [selectedDealer] : []}
              />
              <InputGroupAddon addonType="append" className="serach-icon" style={{ marginTop: '0px' }}>
                <div className="input-group-text" style={{ paddingRight: '5px', marginTop: '-1px' }}>
                  <FontAwesomeIcon htmlFor="datepicker" icon={faSearch} />
                </div>
              </InputGroupAddon>
            </div>
          </Col>
        </Row>

        <Row style={{ marginTop: '12px' }}>
          <Col>
            <Label className="label-right-pan">Invoice in favour of<span className="required-field"> *</span></Label>
            <div className="d-flex-row vehical-sku-id-search">
              <Typeahead
                id="invoiceInFavorOf"
                labelKey="subsidiary_name"
                onChange={(e) => { this.handleInputChange({ target: { name: 'invoiceInFavorOf', value: { subsidiary_id: e && e[0] && e[0].uuid, subsidiary_name: e && e[0] && e[0].subsidiary_name } } }); }}
                options={subsidiaryData}
                placeholder="Type Here"
                renderMenuItemChildren={(selectedItem) => {
                  return <>{selectedItem.subsidiary_name}</>;
                }}
                selected={selectedInvoiceInFavorOf ? [selectedInvoiceInFavorOf] : []}
              />
              <InputGroupAddon addonType="append" className="serach-icon" style={{ marginTop: '0px' }}>
                <div className="input-group-text" style={{ paddingRight: '5px' }}>
                  <FontAwesomeIcon htmlFor="invoiceInFavorOf" icon={faCaretDown} />
                </div>
              </InputGroupAddon>
            </div>

          </Col>
        </Row>

        <div>
          {
            (productDescription.value || []).map((product, index) => (
              <Card key={`key${index}`} style={{ marginTop: '15px', boxShadow: '0px 0px 2px' }}>
                <CardBody>
                  <>
                    <Row>
                      <Col xl="9" md="9" sm="12" xs="12">
                        <div>
                          <Label className="product-desc-qty">
                            Product Description<span className="required-field"> *</span>
                          </Label>
                        </div>
                        <div className="d-flex-row vehical-sku-id-search">
                          <AsyncTypeahead
                            style={{ width: '100%' }}
                            id={`tyreDescription${index}`}
                            filterBy={['sku_id', 'name']}
                            labelKey={(option) => `${option.name}`}
                            options={skuIdData}
                            minLength={2}
                            onChange={(e) => { this.handleProductDescriptionChange(e && e[0], index, 'description'); }}
                            name={`tyreDescription${index}`}
                            onSearch={debounce(200, this.getSKUId)}
                            placeholder="Type Here"
                            useCache={false}
                            renderMenuItemChildren={(selectedItem) => {
                              return <>{selectedItem.name} - {selectedItem.sku_id}</>;
                            }}
                            selected={controls.productDescription.value[index].description ? [controls.productDescription.value[index].description] : []}
                          />
                          <InputGroupAddon addonType="append" className="serach-icon" style={{ marginTop: '0px' }}>
                            <div className="input-group-text" style={{ paddingRight: '5px', marginTop: '-1px' }}>
                              <FontAwesomeIcon htmlFor="datepicker" icon={faSearch} />
                            </div>
                          </InputGroupAddon>
                        </div>
                        {
                          index === 0 &&
                          <div className="skuid-example-text" style={{ marginTop: '7px', marginLeft: '2px' }}>
                            Example: 10.00-20 or Jet or 1132110020018KJRM0
                          </div>
                        }

                      </Col>
                      <Col xl="3" md="3" sm="12" xs="12" style={{ paddingLeft: '0px' }}>
                        <Label className="product-desc-qty">
                          Quantity<span className="required-field"> *</span>
                        </Label>
                        <FontAwesomeIcon onClick={(e) => this.removeProductDesc(index)} icon={faMinusCircle} className="pull-right close-btn" />
                        <Input
                          name={`quantity${index}`}
                          id={`quantity${index}`}
                          placeholder="Type here"
                          value={product.quantity}
                          onChange={(e) => this.handleProductDescriptionChange(e && e.target && e.target.value, index, 'quantity')}
                        />
                      </Col>
                    </Row>

                    {/* <Row style={{ marginTop: '9px' }}>
                   
                    </Row> */}
                  </>
                </CardBody>
              </Card>
            ))
          }
          <div className="custom-link" onClick={this.addMoreEntries} style={{ marginTop: '15px' }}>+ Add more entries</div>
        </div>
      </div >
    );
  }
}

export default AddOfftakeEntryRightPan;